module.exports = __webpack_public_path__ + "img/Taurus_Logo.c794f1f4.png";